import type { ILeadSource } from '@bridebook/models/source/models/Suppliers/Leads.types';
import { IUISupplier } from '@bridebook/toolbox/src/types';
import { fetchy } from '@bridebook/web/lib/fetchy';
import type { EnquiryIntents } from '@bridebook/web/lib/enquiries/intent';
import type { EnquirySendResult } from '@bridebook/web/pages/api/enquiries/enquiry-send';

/**
 * Sends one or many enquiries via the unified async endpoint in a SINGLE request: the leads AND
 * TalkJS conversations are created in the background inside a queue (one job per supplier).
 *
 * A successful response means the enquiries were enqueued (not yet processed).
 */
export const enqueueEnquiry = async ({
  suppliers,
  message,
  intents,
  captchaToken,
  source,
  weddingId,
}: {
  suppliers: IUISupplier[];
  message: string;
  intents: EnquiryIntents;
  captchaToken: string;
  source?: ILeadSource;
  weddingId: string;
}): Promise<{ id: string; results: EnquirySendResult[] }> => {
  const { id, results } = await fetchy().authenticated.post('/api/enquiries/enquiry-send', null, {
    weddingId,
    message,
    intents,
    source,
    supplierIds: suppliers.map((supplier) => supplier.id),
    captchaToken,
  });

  return { id, results };
};

// The suppliers the endpoint reports as sent to.
export const deliveredSupplierIds = (response: { results: EnquirySendResult[] }): Set<string> =>
  new Set(response.results.filter((entry) => entry.success).map((entry) => entry.supplierId));
